// Translations for the application
export const translations = {
  en: {
    // Navbar
    home: "Home",
    about: "About",
    skills: "Skills",
    projects: "Projects",
    contact: "Contact",
    
    // Theme toggle
    darkMode: "Switch to Dark Mode",
    lightMode: "Switch to Light Mode",
    
    // Language toggle
    language: "Language",
    
    // Scroll to top
    scrollToTop: "Scroll to top",
    
    // Hero Section
    greeting: "Hello! My name is",
    name: "Jonathan",
    title: "Software Developer & Singer",
    description: "From Uruguay, I combine art with technology to create things that connect, excite, and make an impact. I'm a software developer and music lover.",
    viewProjects: "View projects",
    contactMe: "Contact",
    scroll: "Move",
    
    // About Preview Section
    aboutMe: "About Me",
    aboutText1: "Hello! My name is Jonathan Pérez, but many people know me as Jona. I am a Uruguayan singer-songwriter with a strong passion for art, music, and creativity. I recently graduated as a Full Stack developer from Holberton School and am currently studying Business Administration at the Faculty of Economic Sciences (UDELAR).",
    aboutText2: "From a very young age, I discovered that my life is deeply connected to expression: through a melody, an idea, or a creative solution to a problem. I believe that art and technology can go hand in hand to transform the world.",
    aboutText3: "I am passionate about learning, creating, and communicating. I sing every day, I program with enthusiasm, and I am always thinking about the next project that will challenge me.",
    learnMore: "Learn more about me",
    
    // Skills Preview Section
    mySkills: "My Skills",
    skillsDescription: "These are some of the technologies and tools I work with on a daily basis.",
    viewAllSkills: "View all my skills",
    
    // Projects Preview Section
    myProjects: "My Projects",
    projectsDescription: "These are some of the projects I have worked on recently.",
    viewAllProjects: "View all projects",
    github: "GitHub",
    demo: "Demo",
    
    // Project descriptions
    casseDescription: "App for buying and selling used electronic products that promotes the circular economy and recycling",
    hbnbDescription: "AirBNB clone (Holberton second quarter final project)",
    arbookDescription: "It's an emotional library with a Pokémon theme where you can capture, store, and relive your feelings as if they were precious creatures worthy of being collected.",
    archDescription: "A modern productivity app that helps you organize your life and achieve your goals.",
    moodiaDescription: "It's an innovative social network that focuses on the personal and emotional process rather than the final result. A space where users authentically share their experiences, emotions and creative, sports, work or personal development processes.",
    
    // Contact CTA Section
    workTogether: "Interested in working together?",
    contactText: "I am open to freelance opportunities, collaborations, and full-time positions. If you have a project in mind or just want to chat, please don't hesitate to contact me!",
    contactButton: "Contact me",
    
    // Footer
    copyright: "All rights reserved.",
    portfolio: "My Professional Portfolio",
    
    // About Page
    aboutPageTitle: "About Me",
    aboutPageDescription: "Learn more about my professional career, education, and passions.",
    myStory: "My Story",
    whatDefinesMe: "What defines me?",
    artisticSoul: "Artistic Soul",
    artisticSoulDesc: "I write songs, compose lyrics, and live every musical process.",
    techEnthusiast: "Tech Enthusiast",
    techEnthusiastDesc: "I enjoy solving problems, creating experiences, and learning new technologies.",
    lifePhilosophy: "Life Philosophy",
    lifePhilosophyDesc: "I believe in perseverance, presence, and the power of visualizing what you want.",
    diverseInterests: "Diverse Interests",
    diverseInterestsDesc: "I love languages, science, cinema, philosophy, football, and above all... art in all its forms.",
    downloadCV: "Download CV",
    
    // Experience Section
    experienceTitle: "Experience in teamwork",
    shellProject: "Development of a Simple Shell in C",
    shellProjectDesc1: "• Implementation of a simple shell capable of executing system commands.",
    shellProjectDesc2: "• Process management, signals, standard input/output, and manual parsing.",
    shellProjectDesc3: "• Collaborative work using Git and agile methodologies.",
    shellProjectSubtitle: "Holberton School — Group project",
    
    airbnbProject: "Copy of the Airbnb Web Interface",
    airbnbProjectDesc1: "• Backend development with Python and MySQL database connection.",
    airbnbProjectDesc2: "• Design and construction of RESTful APIs.",
    airbnbProjectDesc3: "• Route management, data persistence, and unit testing.",
    airbnbProjectSubtitle: "Holberton School — Group project with Python & SQL",
    
    casseProject: "Cassé — Application to promote the circular economy",
    casseProjectDesc1: "• Design and implementation of a multiplatform app in Flutter.",
    casseProjectDesc2: "• Integration with Firebase (Authentication, Firestore, Storage).",
    casseProjectDesc3: "• Teamwork using Scrum methodologies and version control in GitHub.",
    casseProjectDesc4: "• UX/UI focus and mobile-first development.",
    casseProjectSubtitle: "Final Project of Holberton School — Flutter & Firebase",
    
    // Education Section
    educationTitle: "Education",
    fullstackDev: "Full Stack Software Developer",
    fullstackDevDesc1: "• Intensive focus on backend and frontend development, with peer-learning methodologies and real projects.",
    fullstackDevDesc2: "• Development in C, Python, HTML, CSS, JavaScript, React, Flutter, Firebase, MySQL, Git.",
    fullstackDevDesc3: "• Experience in teamwork, problem solving, and agile methodologies.",
    fullstackDevSubtitle: "Holberton School Uruguay",
    
    businessDegree: "Technical Degree in Business Administration",
    businessDegreeDesc1: "• Training in management, accounting, economics, marketing, human resources, and law.",
    businessDegreeDesc2: "• Focus on critical thinking, problem-solving, and real-world administrative practices.",
    businessDegreeSubtitle: "University of the Republic (UdelaR) – School of Economic Sciences and Administration",
    
    // Certifications Section
    certificationsTitle: "Certifications & Courses",
    awsCert: "AWS Cloud Practitioner",
    awsCertDesc: "Foundational understanding of AWS Cloud services and architecture.",
    awsCertIssuer: "Amazon Web Services",
    
    productManagementCert: "Product Management",
    productManagementCertDesc: "Marketing strategies, competitive product development and experience design to gain market preference.",
    productManagementCertIssuer: "Coursera",
    
    reactCert: "Advanced React Development",
    reactCertDesc: "Modern React patterns, hooks, and state management.",
    reactCertIssuer: "Meta (Facebook)",
    
    agileMethodologies: "Agile Methodologies & Scrum",
    agileMethodologiesDesc: "Project management with Scrum framework and agile practices.",
    agileMethodologiesIssuer: "Scrum Alliance",
    foundationsCS: "Foundations of Computer Science",
    foundationsCSDesc: "Fundamentals of computer science, algorithms and data structures.",
    download: "Download",
    view: "View",
    
    // Skills Page
    skillsPageTitle: "My Skills",
    skillsPageDescription: "These are the technologies and tools I work with on a daily basis.",
    frontendDev: "Front-end Development",
    backendDevOps: "Back-end Development and DevOps",
    toolsMore: "Tools and more",
    softSkills: "Soft Skills",
    otherSkills: "Other Skills",
    
    // Soft Skills
    teamwork: "Teamwork",
    communication: "Communication",
    problemSolving: "Problem Solving",
    adaptability: "Adaptability",
    leadership: "Leadership",
    creativity: "Creativity",
    emotionalIntelligence: "Emotional Intelligence",
    
    // Other Skills
    projectManagement: "Project Management",
    languages: "Languages",
    uiUxDesign: "UI/UX Design",
    excel: "Excel",
    
    // Tools
    git: "Git",
    docker: "Docker",
    aws: "AWS",
    figma: "Figma",
    jira: "Jira",
    npm: "npm",
    wordpress: "WordPress",
    shellScripting: "Shell Scripting",
    
    // Projects Page
    projectsPageTitle: "My Projects",
    projectsPageDescription: "Explore the projects I've worked on recently",
    searchProjects: "Search projects...",
    all: "All",
    frontend: "Frontend",
    backend: "Backend",
    fullstack: "Full Stack",
    mobile: "Mobile",
    noProjectsFound: "No projects found",
    tryAnotherSearch: "Try another search or filter",
    
    // Contact Page
    contactPageTitle: "Contact me",
    contactPageDescription: "Do you have any questions or suggestions? Please feel free to contact me.",
    contactInfo: "Contact Information",
    email: "Email",
    phone: "Mobile phone",
    location: "Location",
    formName: "Name",
    subject: "Subject",
    message: "Message",
    sendMessage: "Send Message",
    sending: "Sending...",
    messageSent: "Message sent successfully! I will respond as soon as possible.",
    messageError: "There was an error sending the message. Please try again.",
    
    // AI Chat
    aiAssistant: "AI Assistant",
    aiGreeting: "Hi! I'm Jonathan's assistant. How can I help you?",
    typeMessage: "Type your message...",
    typing: "Typing...",
    aiConnectionError: "Sorry, I couldn't connect to the AI server. Make sure Ollama is running."
  },
  es: {
    // Navbar
    home: "Inicio",
    about: "Sobre mí",
    skills: "Habilidades",
    projects: "Proyectos",
    contact: "Contacto",
    
    // Theme toggle
    darkMode: "Cambiar a modo oscuro",
    lightMode: "Cambiar a modo claro",
    
    // Language toggle
    language: "Idioma",
    
    // Scroll to top
    scrollToTop: "Volver arriba",
    
    // Hero Section
    greeting: "¡Hola! Mi nombre es",
    name: "Jonathan",
    title: "Programador & Cantante",
    description: "Desde Uruguay, combino el arte con la tecnología para crear cosas que conectan, emocionan y generan impacto. Soy desarrollador de software y amante de la música.",
    viewProjects: "Ver proyectos",
    contactMe: "Contacto",
    scroll: "Desplazar",
    
    // About Preview Section
    aboutMe: "Sobre Mí",
    aboutText1: "¡Hola! Mi nombre es Jonathan Pérez, pero muchas personas me conocen como Jona. Soy un cantautor uruguayo con una fuerte pasión por el arte, la música y la creatividad. Actualmente, me gradué como desarrollador Full Stack en Holberton School y me encuentro estudiando Administración de Empresas en la Facultad de Ciencias Económicas (UDELAR).",
    aboutText2: "Desde muy joven, descubrí que mi vida está profundamente conectada con la expresión: a través de una melodía, una idea o una solución creativa a un problema. Creo que el arte y la tecnología pueden ir de la mano para transformar el mundo.",
    aboutText3: "Me apasiona aprender, crear y comunicar. Canto todos los días, programo con entusiasmo y siempre estoy pensando en el próximo proyecto que me desafíe.",
    learnMore: "Conocer más sobre mí",
    
    // Skills Preview Section
    mySkills: "Mis Habilidades",
    skillsDescription: "Estas son algunas de las tecnologías y herramientas con las que trabajo diariamente.",
    viewAllSkills: "Ver todas mis habilidades",
    
    // Projects Preview Section
    myProjects: "Mis Proyectos",
    projectsDescription: "Estos son algunos de los proyectos en los que he trabajado recientemente.",
    viewAllProjects: "Ver todos los proyectos",
    github: "GitHub",
    demo: "Demo",
    
    // Project descriptions
    casseDescription: "Aplicación para comprar y vender productos electrónicos usados que promueve la economía circular y el reciclaje",
    hbnbDescription: "Clon de AirBNB (proyecto final del segundo trimestre de Holberton)",
    arbookDescription: "Es una biblioteca emocional con temática Pokémon donde puedes capturar, almacenar y revivir tus sentimientos como si fueran criaturas preciosas dignas de ser coleccionadas.",
    archDescription: "Una aplicación moderna de productividad que te ayuda a organizar tu vida y alcanzar tus metas.",
    moodiaDescription: "Es una red social innovadora que pone el foco en el proceso personal y emocional en lugar del resultado final. Un espacio donde los usuarios comparten de forma auténtica sus vivencias, emociones y procesos creativos, deportivos, laborales o de desarrollo personal.",
    
    // Contact CTA Section
    workTogether: "¿Interesado en trabajar juntos?",
    contactText: "Estoy abierto a oportunidades freelance, colaboraciones y posiciones de tiempo completo. Si tienes un proyecto en mente o simplemente quieres charlar, ¡no dudes en contactarme!",
    contactButton: "Contáctame",
    
    // Footer
    copyright: "Todos los derechos reservados.",
    portfolio: "Mi Portafolio Profesional",
    
    // About Page
    aboutPageTitle: "Sobre Mí",
    aboutPageDescription: "Conoce más sobre mi carrera profesional, educación y pasiones.",
    myStory: "Mi Historia",
    whatDefinesMe: "¿Qué me define?",
    artisticSoul: "Alma Artística",
    artisticSoulDesc: "Escribo canciones, compongo letras y vivo cada proceso musical.",
    techEnthusiast: "Entusiasta de la Tecnología",
    techEnthusiastDesc: "Disfruto resolviendo problemas, creando experiencias y aprendiendo nuevas tecnologías.",
    lifePhilosophy: "Filosofía de Vida",
    lifePhilosophyDesc: "Creo en la perseverancia, la presencia y el poder de visualizar lo que quieres.",
    diverseInterests: "Intereses Diversos",
    diverseInterestsDesc: "Me encantan los idiomas, la ciencia, el cine, la filosofía, el fútbol y sobre todo... el arte en todas sus formas.",
    downloadCV: "Descargar CV",
    
    // Experience Section
    experienceTitle: "Experiencia en trabajo en equipo",
    shellProject: "Desarrollo de un Simple Shell en C",
    shellProjectDesc1: "• Implementación de un shell simple capaz de ejecutar comandos del sistema.",
    shellProjectDesc2: "• Gestión de procesos, señales, entrada/salida estándar y análisis manual.",
    shellProjectDesc3: "• Trabajo colaborativo utilizando Git y metodologías ágiles.",
    shellProjectSubtitle: "Holberton School — Proyecto grupal",
    
    airbnbProject: "Copia de la Interfaz Web de Airbnb",
    airbnbProjectDesc1: "• Desarrollo backend con Python y conexión a base de datos MySQL.",
    airbnbProjectDesc2: "• Diseño y construcción de APIs RESTful.",
    airbnbProjectDesc3: "• Gestión de rutas, persistencia de datos y pruebas unitarias.",
    airbnbProjectSubtitle: "Holberton School — Proyecto grupal con Python y SQL",
    
    casseProject: "Cassé — Aplicación para promover la economía circular",
    casseProjectDesc1: "• Diseño e implementación de una aplicación multiplataforma en Flutter.",
    casseProjectDesc2: "• Integración con Firebase (Autenticación, Firestore, Storage).",
    casseProjectDesc3: "• Trabajo en equipo utilizando metodologías Scrum y control de versiones en GitHub.",
    casseProjectDesc4: "• Enfoque en UX/UI y desarrollo mobile-first.",
    casseProjectSubtitle: "Proyecto Final de Holberton School — Flutter y Firebase",
    
    // Education Section
    educationTitle: "Educación",
    fullstackDev: "Desarrollador Full Stack",
    fullstackDevDesc1: "• Enfoque intensivo en desarrollo backend y frontend, con metodologías de aprendizaje entre pares y proyectos reales.",
    fullstackDevDesc2: "• Desarrollo en C, Python, HTML, CSS, JavaScript, React, Flutter, Firebase, MySQL, Git.",
    fullstackDevDesc3: "• Experiencia en trabajo en equipo, resolución de problemas y metodologías ágiles.",
    fullstackDevSubtitle: "Holberton School Uruguay",
    
    businessDegree: "Técnico en Administración de Empresas",
    businessDegreeDesc1: "• Formación en gestión, contabilidad, economía, marketing, recursos humanos y derecho.",
    businessDegreeDesc2: "• Enfoque en pensamiento crítico, resolución de problemas y prácticas administrativas del mundo real.",
    businessDegreeSubtitle: "Universidad de la República (UdelaR) – Facultad de Ciencias Económicas y Administración",
    
    // Certifications Section
    certificationsTitle: "Certificaciones y Cursos",
    awsCert: "AWS Cloud Practitioner",
    awsCertDesc: "Comprensión fundamental de los servicios y arquitectura de AWS Cloud.",
    awsCertIssuer: "Amazon Web Services",
    
    productManagementCert: "Product Management",
    productManagementCertDesc: "Estrategias de marketing, desarrollo de productos competitivos y diseño de experiencias para ganar la preferencia del mercado.",
    productManagementCertIssuer: "Coursera",
    
    reactCert: "Desarrollo Avanzado en React",
    reactCertDesc: "Patrones modernos de React, hooks y gestión de estado.",
    reactCertIssuer: "Meta (Facebook)",
    
    agileMethodologies: "Metodologías Ágiles y Scrum",
    agileMethodologiesDesc: "Gestión de proyectos con framework Scrum y prácticas ágiles.",
    agileMethodologiesIssuer: "Scrum Alliance",
    foundationsCS: "Fundamentos de Ciencias de la Computación",
    foundationsCSDesc: "Fundamentos de ciencias de la computación, algoritmos y estructuras de datos.",
    download: "Descargar",
    view: "Ver",
    
    // Skills Page
    skillsPageTitle: "Mis Habilidades",
    skillsPageDescription: "Estas son las tecnologías y herramientas con las que trabajo diariamente.",
    frontendDev: "Desarrollo Front-end",
    backendDevOps: "Desarrollo Back-end y DevOps",
    toolsMore: "Herramientas y más",
    softSkills: "Habilidades Blandas",
    otherSkills: "Otras Habilidades",
    
    // Soft Skills
    teamwork: "Trabajo en equipo",
    communication: "Comunicación",
    problemSolving: "Resolución de problemas",
    adaptability: "Adaptabilidad",
    leadership: "Liderazgo",
    creativity: "Creatividad",
    emotionalIntelligence: "Inteligencia emocional",
    
    // Other Skills
    projectManagement: "Gestión de proyectos",
    languages: "Idiomas",
    uiUxDesign: "Diseño UI/UX",
    excel: "Excel",
    
    // Tools
    git: "Git",
    docker: "Docker",
    aws: "AWS",
    figma: "Figma",
    jira: "Jira",
    npm: "npm",
    wordpress: "WordPress",
    shellScripting: "Scripting en Shell",
    
    // Projects Page
    projectsPageTitle: "Mis Proyectos",
    projectsPageDescription: "Explora los proyectos en los que he trabajado recientemente",
    searchProjects: "Buscar proyectos...",
    all: "Todos",
    frontend: "Frontend",
    backend: "Backend",
    fullstack: "Full Stack",
    mobile: "Móvil",
    noProjectsFound: "No se encontraron proyectos",
    tryAnotherSearch: "Intenta otra búsqueda o filtro",
    
    // Contact Page
    contactPageTitle: "Contáctame",
    contactPageDescription: "¿Tienes alguna pregunta o sugerencia? No dudes en contactarme.",
    contactInfo: "Información de Contacto",
    email: "Correo electrónico",
    phone: "Teléfono móvil",
    location: "Ubicación",
    formName: "Nombre",
    subject: "Asunto",
    message: "Mensaje",
    sendMessage: "Enviar Mensaje",
    sending: "Enviando...",
    messageSent: "¡Mensaje enviado con éxito! Responderé lo antes posible.",
    messageError: "Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo.",
    
    // AI Chat
    aiAssistant: "Asistente IA",
    aiGreeting: "¡Hola! Soy el asistente de Jonathan. ¿En qué puedo ayudarte?",
    typeMessage: "Escribe tu mensaje...",
    typing: "Escribiendo...",
    aiConnectionError: "Lo siento, no pude conectar con el servidor de IA. Asegúrate de que Ollama esté ejecutándose."
  }
};